import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export const getSessionDetailOptions = (sessionId: string) =>
  trpcOptions.app.getSessionDetail.queryOptions({ sessionId })

export function useGetSessionDetail(sessionId: string) {
  return useQuery(getSessionDetailOptions(sessionId))
}
